function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import ShowCategories from "@common/components/show/ShowCategories";
import { getDateAndTime } from "@common/services/helpers";
import { VOD_CATEGORIES_DEFAULT_OPTIONS, VOD_CATEGORIES_OPTIONS } from "@config/constants";
import { isEmpty, isNil } from "lodash";
var ChannelInfo = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ChannelInfo, Component);
    var _super = _create_super(ChannelInfo);
    function ChannelInfo() {
        _class_call_check(this, ChannelInfo);
        return _super.apply(this, arguments);
    }
    _create_class(ChannelInfo, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var epgs = this.props.epgs;
                return epgs && (epgs.current !== nextProps.epgs.current || epgs.next !== nextProps.epgs.next);
            }
        },
        {
            key: "render",
            value: function render() {
                var template = null;
                var _this_props = this.props, epgs = _this_props.epgs, i18n = _this_props.i18n, isVod = _this_props.isVod;
                if (epgs && epgs.all && epgs.all.length > 0) {
                    var _VOD_CATEGORIES_OPTIONS_epgs_current_majorId, _VOD_CATEGORIES_OPTIONS_epgs_current_majorId1, _epgs_current_numeration, _epgs_current_numeration1, _epgs_next_numeration, _epgs_next_numeration1;
                    var showEpisodeNumberInPlayerOption = !isEmpty(VOD_CATEGORIES_OPTIONS) && !isNil((_VOD_CATEGORIES_OPTIONS_epgs_current_majorId = VOD_CATEGORIES_OPTIONS[epgs.current.majorId]) === null || _VOD_CATEGORIES_OPTIONS_epgs_current_majorId === void 0 ? void 0 : _VOD_CATEGORIES_OPTIONS_epgs_current_majorId.showEpisodeNumberInPlayer) ? (_VOD_CATEGORIES_OPTIONS_epgs_current_majorId1 = VOD_CATEGORIES_OPTIONS[epgs.current.majorId]) === null || _VOD_CATEGORIES_OPTIONS_epgs_current_majorId1 === void 0 ? void 0 : _VOD_CATEGORIES_OPTIONS_epgs_current_majorId1.showEpisodeNumberInPlayer : VOD_CATEGORIES_DEFAULT_OPTIONS.showEpisodeNumberInPlayer;
                    var currentEpisodeNumber = "".concat(i18n.common.season, " ").concat((_epgs_current_numeration = epgs.current.numeration) === null || _epgs_current_numeration === void 0 ? void 0 : _epgs_current_numeration.SeasonNumber, " ").concat(i18n.common.episode, " ").concat((_epgs_current_numeration1 = epgs.current.numeration) === null || _epgs_current_numeration1 === void 0 ? void 0 : _epgs_current_numeration1.EpisodeNumber);
                    template = /*#__PURE__*/ _jsxs("div", {
                        className: "channel-information",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "current-show",
                                children: [
                                    !isVod && /*#__PURE__*/ _jsx("div", {
                                        "aria-hidden": true,
                                        className: "duration",
                                        dangerouslySetInnerHTML: getDateAndTime(epgs.current.start, epgs.current.stop, i18n.months)
                                    }),
                                    isVod && epgs.all.length > 1 && showEpisodeNumberInPlayerOption && /*#__PURE__*/ _jsx("div", {
                                        className: "duration",
                                        children: currentEpisodeNumber
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "title",
                                        children: epgs.current.title
                                    }),
                                    /*#__PURE__*/ _jsx(ShowCategories, {
                                        minorCategories: epgs.current["minor_categories"] || epgs.current.categories,
                                        majorCategory: epgs.current["major_category"]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "description",
                                        children: epgs.current.subtitle
                                    })
                                ]
                            }),
                            !isEmpty(epgs.next) && /*#__PURE__*/ _jsxs("div", {
                                className: "next-show",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "next",
                                        children: "следва"
                                    }),
                                    !isVod && /*#__PURE__*/ _jsx("div", {
                                        "aria-hidden": true,
                                        className: "duration",
                                        dangerouslySetInnerHTML: getDateAndTime(epgs.next.start, epgs.next.stop, i18n.months)
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "title",
                                        children: isVod && showEpisodeNumberInPlayerOption ? "".concat(i18n.common.season, " ").concat((_epgs_next_numeration = epgs.next.numeration) === null || _epgs_next_numeration === void 0 ? void 0 : _epgs_next_numeration.SeasonNumber, " ").concat(i18n.common.episode, " ").concat((_epgs_next_numeration1 = epgs.next.numeration) === null || _epgs_next_numeration1 === void 0 ? void 0 : _epgs_next_numeration1.EpisodeNumber) : epgs.next.title
                                    }),
                                    !isVod && /*#__PURE__*/ _jsx("div", {
                                        className: "category",
                                        children: epgs.next["major_category"]
                                    })
                                ]
                            })
                        ]
                    });
                }
                return template;
            }
        }
    ]);
    return ChannelInfo;
}(Component);
export default ChannelInfo;
